module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "add-song",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("添加歌曲到列表")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "search-box-wrapper"
  }, [_c('search-box', {
    ref: "searchBox",
    attrs: {
      "placeholder": "搜索歌曲"
    },
    on: {
      "query": _vm.onQueryChange
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.query),
      expression: "!query"
    }],
    staticClass: "shortcut"
  }, [_c('switches', {
    attrs: {
      "switches": _vm.switches,
      "currentIndex": _vm.currentIndex
    },
    on: {
      "switch": _vm.switchItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "list-wrapper"
  }, [(_vm.currentIndex === 0) ? _c('scroll', {
    ref: "songList",
    staticClass: "list-scroll",
    attrs: {
      "data": _vm.playHistory
    }
  }, [_c('div', {
    staticClass: "list-inner"
  }, [_c('song-list', {
    attrs: {
      "songs": _vm.playHistory
    },
    on: {
      "select": _vm.selectSong
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentIndex === 1) ? _c('scroll', {
    ref: "searchList",
    staticClass: "list-scroll",
    attrs: {
      "refreshDelay": _vm.refreshDelay,
      "data": _vm.searchHistory
    }
  }, [_c('div', {
    staticClass: "list-inner"
  }, [_c('search-list', {
    attrs: {
      "searches": _vm.searchHistory
    },
    on: {
      "delete": _vm.deleteSearchHistory,
      "select": _vm.addQuery
    }
  })], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "search-result"
  }, [_c('suggest', {
    attrs: {
      "query": _vm.query,
      "showSinger": _vm.showSinger
    },
    on: {
      "select": _vm.selectSuggest,
      "listScroll": _vm.blurInput
    }
  })], 1), _vm._v(" "), _c('top-tip', {
    ref: "topTip"
  }, [_c('div', {
    staticClass: "tip-title"
  }, [_c('i', {
    staticClass: "icon-ok"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("1首歌曲已经添加到播放列表")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-213c2fc0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/add-song/add-song.vue
// module id = 529
// module chunks = 9